import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';

export const Schema = Yup.object().shape({
    salaryRequest: Yup.number()
        .nullable(true)
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val <= 999999999;
            return true;
        })
        .required("Angabe ist erforderlich"),
});

export const SalaryRequestSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formSalaryRequest">
                <Form.Label>Gewünschtes Jahresgehalt*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Jährlichen Gehaltswunsch eingeben"
                    type="text"
                    name="salaryRequest"
                    value={values.salaryRequest || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.salaryRequest && !errors.salaryRequest}
                    isInvalid={touched.salaryRequest && errors.salaryRequest}
                    maxLength={9}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequest}
                </Form.Control.Feedback>
            </Form.Group>
      </>
    );
};